import React from 'react';

export default function SearchBar({ value, onChange }) {
  return (
    <div style={{ position: 'relative', flex: 1, minWidth: 220, maxWidth: 320 }}>
      <svg style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
        width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="6" cy="6" r="4.5" stroke="var(--text-tertiary)" strokeWidth="1.3"/>
        <path d="M10 10l2 2" stroke="var(--text-tertiary)" strokeWidth="1.3" strokeLinecap="round"/>
      </svg>
      <input
        type="text"
        placeholder="Search by name or address..."
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '7px 12px 7px 32px',
          borderRadius: 100,
          border: '1px solid var(--border)',
          background: 'var(--bg-card)',
          color: 'var(--text-primary)',
          fontSize: 13,
          fontFamily: 'var(--font-body)',
          outline: 'none',
          transition: 'border-color var(--transition)',
        }}
        onFocus={e => e.target.style.borderColor = 'var(--accent)'}
        onBlur={e => e.target.style.borderColor = 'var(--border)'}
      />
    </div>
  );
}
